import { defineStore } from 'pinia'


export const useDialogStore = defineStore({
  id: 'dialog',
  state: () => ({
    dialog_put_adena: false,
    dialog_take_adena: false,
    dialog_low_cap: false,
    dialog_sub_telegram: false,
    dialog_error_code: false,
    dialog_alert: {
      status: false,
      text: { error: [] },
      timeout: 2000,
      typeIcon: null,
      data: {
        low_cap: false,
        sert: null,
        accept: false
      }
    },
    dialog_user_variant: false,
    dialog_success_delete_user_variant: {
      status: false,
      summa: null
    },
    dialog_create_success: {
      status: false,
      summa: null,
      count: null,
      nominal: null
    },
    dialog_not_select_server: {
      status: false,
      timeout: 2000

    },
    dialog_vip: false,
    dialog_put_adena_summa: null

  }),

  actions: {
    dialog_all_close() {
      this.$reset()

    },

    open_dialog_put_adena(summa = null) {
      this.dialog_low_cap = false
      this.dialog_put_adena = true
      this.dialog_put_adena_summa = summa

    },
    close_dialog_put_adena() {

      this.dialog_put_adena = false

    },

    open_dialog_take_adena() {

      this.dialog_take_adena = true

    },

    close_dialog_take_adena() {
      this.dialog_take_adena = false
    },



    open_dialog_user_variant() {
      this.$reset()
      this.dialog_user_variant = true

    },
    open_dialog_sub_telegram() {
      this.dialog_sub_telegram = true
    },
    close_dialog_sub_telegram() {
      this.dialog_sub_telegram = false
    },
    open_dialog_alert(data) {
      this.dialog_alert.text = data.text
      this.dialog_alert.status = true
      this.dialog_alert.typeIcon = data.typeIcon || null
      if (data.sert) {
        this.dialog_alert.data.sert = data.sert
        this.dialog_alert.data.accept = true
      }
      if (data.low_cap) {
        this.dialog_alert.data.low_cap = true
        this.dialog_alert.data.accept = true
      }
      console.log(this.dialog_alert);


    },
    open_dialog_low_cap() {
      this.dialog_low_cap = true
    },
    dialog_low_cap_close() {
      this.dialog_low_cap = false
    },

    open_dialog_error_code() {
      this.dialog_error_code = true
    },
    close_dialog_error_code() {
      this.dialog_error_code = false
    },
    dialog_alert_close() {
      Object.assign(this.dialog_alert, { status: false, text: { error: [] }, typeIcon: null, data: { sert: null, accept: false, low_cap: false } })

    },
    open_dialog_success_delete_user_varian(data) {
      let obj = { status: true, summa: data.summa }
      Object.assign(this.dialog_success_delete_user_variant, obj)
      console.log(this.dialog_success_delete_user_variant);

    },


    close_dialog_success_delete_user_varian() {
      let obj = { status: false, summa: null }
      Object.assign(this.dialog_success_delete_user_variant, obj)

    },
    open_dialog_create_success(data) {
      let obj = { status: true, summa: data.summa, count: data.count, nominal: data.nominal }
      Object.assign(this.dialog_create_success, obj)


    },
    close_dialog_create_success() {
      let obj = { status: false, summa: null, count: null }
      Object.assign(this.dialog_create_success, obj)

    },
    open_dialog_not_select_server() {
      this.dialog_not_select_server.status = true
    },
    close_dialog_not_select_server() {
      this.dialog_not_select_server.status = false
    },
    open_dialog_vip() {
      this.dialog_vip = true
    }

  }
})
